var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0714 7.9234L16.8674 6.1274C17.4127 5.58215 17.6853 5.30952 17.8311 5.01543C18.1083 4.45588 18.1083 3.79892 17.8311 3.23937C17.6853 2.94527 17.4127 2.67265 16.8674 2.1274C16.3222 1.58215 16.0496 1.30952 15.7555 1.16379C15.1959 0.886505 14.539 0.886505 13.9794 1.16379C13.6853 1.30952 13.4127 1.58215 12.8674 2.1274L11.0488 3.94605C12.0127 5.59665 13.3988 6.97222 15.0714 7.9234ZM9.59433 5.40051L2.72383 12.271C2.29877 12.6961 2.08624 12.9086 1.9465 13.1697C1.80677 13.4308 1.74782 13.7255 1.62993 14.315L1.01454 17.392C0.948013 17.7246 0.914752 17.8909 1.00936 17.9855C1.10397 18.0801 1.27027 18.0468 1.60288 17.9803L4.67986 17.3649C5.26932 17.247 5.56404 17.1881 5.82514 17.0483C6.08624 16.9086 6.29877 16.6961 6.72383 16.271L13.6132 9.38162C11.9916 8.36597 10.6199 7.00367 9.59433 5.40051Z",
    fill: "#5664D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.20d4af406d4cbec3e644c896bd8eaffd.svg";
export { ForwardRef as ReactComponent };